module.exports = __webpack_public_path__ + "img/login_tab02_02.1ad2b2c5.png";